import { useState } from 'react';

export default function(initialState) {
  const [values, setValue] = useState(initialState);

  const handleFieldChange = (fieldKey, e) => {
    setValue({
      ...values,
      [fieldKey]: e.target.value,
    });
  };

  return { values, handleFieldChange };
}



// WEBPACK FOOTER //
// ./src/hooks/use-field-change.js